export * from "./theme-switcher.component";